import { format } from 'date-fns';
import { RosterVersion } from '../services/rosterService';

const compareVersions = (left: RosterVersion, right: RosterVersion) =>
    left.versionNumber - right.versionNumber;

export const getMonthRevisionNumber = (
    version: RosterVersion,
    versionsForMonth: RosterVersion[]
) => {
    const ordered = [...versionsForMonth].sort(compareVersions);
    const index = ordered.findIndex(candidate => candidate.id === version.id);
    return index >= 0 ? index + 1 : 1;
};

export const getRosterVersionLabel = (
    version: RosterVersion,
    versionsForMonth: RosterVersion[]
) => `${format(new Date(version.startDate), 'MMMM yyyy')} Roster v${getMonthRevisionNumber(version, versionsForMonth)}`;
